<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之围栏列表开始-->
	<div class="tab-bar">
		<div class="tab-row ">
		  	<div class="car_fence ">
				<ul>
					<li v-for="(fence,index) in fenceArr">
						<dl>
							<dt><span>{{fence.areaName}}</span><a class="ico_close" @click="deleteFence(fence.iD)"></a></dt>
							<dd><i><a  class="ico_01a" @click="showFence(index,fence.iD,JSON.parse(fence.pOINTS))">{{fence.showFlag?'显示':'隐藏'}}</a></i>
								<i><a  class="ico_02" @click="addTab(fence.areaName,fence.iD)">车辆</a></i></dd>
						</dl>
					</li>
				</ul>
				<laypage ref="fenceLay" :pages="pagesTotal" v-on:changePage="cb" :groups="pagesTotal > 3 ? 3 : pagesTotal" :first="first" :last="last" :prev="prev" :next="next" class="laypage"></laypage>		
		  	</div>              
		</div>
	</div>
	<!--车辆监控页面_右侧tab面板之围栏列表结束-->
</template>
<script>
	import {setSessionStore,getSessionStore} from 'util/util'
	import {mapState} from 'vuex'
	import Laypage from 'components/common/vueLaypage/Laypage'
	import {INFO_EMPTY,OPERATE_EXCEPTION} from 'static/message'
	export default {
		name: 'FenceList',
		components:{
			Laypage
		},
		data() {
			return {
				firstOpen:true, //是否第一次打开
				fenceArr:[],
				vehicleAmount:0,
				pagesTotal:0, //总页数
		        first:false, //不显示首页
		        last:false,	//不显示尾页
		        prev: '上一页',
		        next: '下一页'
			}
		},
		computed: {
			...mapState({
				areaType:state=>state.monitor.areaType,
				areaInfo:state=>state.monitor.areaInfo,
				groupId:state=>state.user.groupid,
				clearFlag:state=>state.monitor.clearFlag
				
			})
		},
		watch:{
			areaInfo:function(val){
				if(this.areaType==1){
					
					this.pagesTotal = val.pages;
					this.$nextTick(function(){
						this.$refs.fenceLay.setPage(val.pageNum)
					})
					this.fenceArr = val.list
					if(!this.firstOpen){
						let arr = getSessionStore('fenceArr')
						let curFence = JSON.parse(arr)
						for(let i = 0,length = this.fenceArr.length; i < length; i ++){
							let index = curFence.findIndex(n=>n.iD==this.fenceArr[i].iD)
							if(index!=-1){
								this.fenceArr[i].showFlag=curFence[index].showFlag
								this.fenceArr[i].clickCount=curFence[index].clickCount
							}else{
								this.fenceArr[i].showFlag = true;
								this.fenceArr[i].clickCount = 0;
							}
						}
					}else{
						this.initList()
					}
					const that = this
					setSessionStore('fenceArr',that.fenceArr)
				}
			},
			clearFlag(val){
				if(val){
					this.initList()
					this.$store.dispatch('clearMap',false)
				}
			}
		},
		destroyed(){
			this.initList()
		},
		methods: {
			initList(){
				this.firstOpen = false
				for(let i = 0,length = this.fenceArr.length; i < length; i ++){
					this.fenceArr[i].showFlag = true;
					this.fenceArr[i].clickCount = 0;
					this.fenceArr.splice(i,1,this.fenceArr[i])
				}
				const that = this
				setSessionStore('fenceArr',that.fenceArr)
			},
			cb(page) {//分页组件回调
		        this.page = page
		        const param = {
		        	page_index:page,
					areaType:1,
					customerId:this.groupId
		        }
		        this.$store.dispatch('getAreaList',param)
		   	},
			showFence(index,id,pointArr){
				this.fenceArr[index].clickCount ++;
				this.fenceArr.splice(index,1,this.fenceArr[index])
				if(this.fenceArr[index].clickCount % 2 == 0){//隐藏
					this.fenceArr[index].showFlag = true;
					this.fenceArr.splice(index,1,this.fenceArr[index])
					this.$store.dispatch('removeFence',id)
				}else{//显示
					this.fenceArr[index].showFlag = false;
					this.fenceArr.splice(index,1,this.fenceArr[index])
					const obj = {
						points:pointArr,
						id:id
					}
					this.$store.dispatch('fenceToMap',obj)
				}
				const that = this
				setSessionStore('fenceArr',that.fenceArr)
			},
			deleteFence(id){//删除围栏
				let random = Math.random().toString(36).substr(2);
				this.$http.get(process.env.API_ROOT + '/monitor/areas/' + id + '/vehicle-count?random=' + random)
					.then((res)=>{
						if(res.body.data==0){
							const obj = {
								id:id,
								type:'围栏',
								delType:'fence',
								areaType:1
							}
							this.$store.dispatch('deleteModalShow',obj)
						}else{
							let str = '该围栏区域中尚有'+ res.body.data +'个车辆，不能删除该围栏'
							this.$store.dispatch('tipModalShow',str)
						}
					},(res)=>{
						this.$store.dispatch('tipModalShow',res.body.message)
					})
					.catch((res)=>{
						this.$store.dispatch('tipModalShow',OPERATE_EXCEPTION)
					})
				
			},
			addTab(name,id){//点击车辆-跳转到围栏名称--监控车辆标签
				const obj = {
					name:name + '-监控车辆',
					id:'PageFenceMonitorVehicle',
					route:'/indexhome/fenceMonitorVehicle' + id,
					No:'fence' + id
				}
				this.$router.push({path:'/indexhome/fenceMonitorVehicle' + id,query:{id: id}});
				this.$store.dispatch('addTab',obj);
			}

		}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// FenceList.vue?7fcc6756